import { render, staticRenderFns } from "./back-stock-pick-h5.vue?vue&type=template&id=a19d9910&scoped=true"
import script from "./back-stock-pick-h5.vue?vue&type=script&lang=js"
export * from "./back-stock-pick-h5.vue?vue&type=script&lang=js"
import style0 from "./back-stock-pick-h5.vue?vue&type=style&index=0&id=a19d9910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19d9910",
  null
  
)

export default component.exports